import type { OutOfDatePublicationVariant } from './useOutOfDatePublicationVariant';

// "regenerate" keeps its old i18n namespace (RegenerateAction); "update" is
// the renamed republish flow (was RepublishButton) — see MED-6969 follow-up.
export const HINT_KEYS: Record<OutOfDatePublicationVariant, string> = {
  regenerate: 'components.RegenerateAction.hint',
  update: 'components.UpdatePublicationAction.hint',
};

// Experience-v2 hint: media or any add-on can be the stale item there.
export const REGENERATE_ITEMS_HINT_KEY = 'components.RegenerateAction.itemsHint';

export const ACTION_KEYS: Record<OutOfDatePublicationVariant, string> = {
  regenerate: 'components.RegenerateAction.action',
  update: 'components.UpdatePublicationAction.action',
};

export const DISMISS_KEYS: Record<OutOfDatePublicationVariant, string> = {
  regenerate: 'components.RegenerateAction.dismiss',
  update: 'components.UpdatePublicationAction.dismiss',
};
